<button mat-raised-button color="{{uiArtefakt.Color.toLowerCase()}}"
        [disabled]="isDisabled || loading" class="lv-primary-button"
        (click)="onCommand()">
  <div *ngIf="loading" class="lv-download-button-content">
    <div class="lv-icon-button-state">
      <mat-progress-spinner mode="indeterminate"
                            [color]="'accent'"
                            [diameter]="20"></mat-progress-spinner>
    </div>
    <div>{{uiArtefakt.Text}}</div>
  </div>
  <div *ngIf="!loading && !isDownloaded" class="lv-download-button-content">
    <div>
      <mat-icon class="lv-icon-button-state" [svgIcon]="'DownloadToLine'"></mat-icon>
    </div>
    <div>{{uiArtefakt.Text}}</div>
  </div>
  <div *ngIf="isDownloaded && !loading" class="lv-download-button-content">
    <div>
      <mat-icon class="lv-icon-button-state" [svgIcon]="'Check'"></mat-icon>
    </div>
    <div>{{uiArtefakt.Text}}</div>
  </div>
</button>
